module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('router-link', {
    staticClass: "button centered",
    attrs: {
      "to": {
        name: 'BrokerageHouseCreator'
      }
    }
  }, [_vm._v("Добавить брокерскую палату")])], 1), _vm._v(" "), _c('draggable', {
    staticClass: "columns is-multiline mt-10",
    model: {
      value: (_vm.brokerageHousesObject),
      callback: function($$v) {
        _vm.brokerageHousesObject = $$v
      },
      expression: "brokerageHousesObject"
    }
  }, _vm._l((_vm.brokerageHousesObject), function(house) {
    return _c('BrokerageHouseItem', {
      key: house.id,
      staticClass: "column is-one-quarter",
      attrs: {
        "house": house
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05fcc019"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrokerageHouses.vue
// module id = 887
// module chunks = 0